import { OtherUserIntegration } from './integration-types';

export enum OrgRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  VIEWER = 'VIEWER',
  CUSTOM = 'CUSTOM',
}

export interface User {
  id: number;
  avatar: { imageUrl: string } | null;
  displayName: string;
  title: string;
  emailAddress: string;
  emailVerified?: boolean;
  orgRoles: OrgRole[];
  onCall: boolean;
  integrations: OtherUserIntegration[];
}

export enum TimePreferenceDay {
  EVERYDAY = 'EVERYDAY',
  WEEKDAY = 'WEEKDAY',
  WEEKEND = 'WEEKEND',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface TimePreference {
  day: TimePreferenceDay;
  start: number;
  startMinute: number;
  end: number;
  endMinute: number;
}

export type MinimalUser = Pick<User, 'id' | 'displayName' | 'avatar'>;
